<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title>
        <span>{{ title }}</span>
        <mat-icon class="icon" *ngIf="showIcon" [color]="iconcolor">{{ iconname }}</mat-icon>
    </h1>
    <div class="centerwrap scroll" fxFlex.gt-sm="auto"><div [innerHTML]="message | safeHTML"></div></div>
    <div>
        <div
            fxLayout="row"
            fxLayoutAlign="end center"
            fxLayoutGap="15px"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="center center"
            fxLayoutGap.lt-md="10px"
        >
            <button mat-raised-button *ngFor="let opt of options" [color]="opt.Color" (click)="OptionHandler(opt.Response)">
                {{ opt.DisplayText }}
            </button>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/services/dialogs/optionbox/optionbox.dialogcomponent.html